import React, { useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  Dialog,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import closeIcon from "@assets/images/close.svg";
import { PopupStyle } from "./style";


function Popup(props) {
  const classes = PopupStyle();
  const [scroll] = useState("body");

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img src={closeIcon} alt="Close" onClick={props.handleClose}/>
      </div>
      <DialogTitle id="alert-dialog-title">Bulk Upload Errors</DialogTitle>
      <DialogContent>
        <div className={classes.warningResult}>
          Please correct the following records and try again.
        </div>
        <div className={classes.TableWrapper}>
          <TableContainer className={classes.customTable}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell className="no">No</TableCell>
                  <TableCell className="city">City</TableCell>
                  <TableCell className="customer">Customer</TableCell>
                  <TableCell className="fuelSurcharge">Fuel Surcharge</TableCell>
                  <TableCell className="startDate">Start Date</TableCell>
                  <TableCell className="error">Error</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props?.data?.length === 0 ? (
                  <TableRow>
                    <TableCell>No Data Found</TableCell>
                  </TableRow>
                ) : (
                  props?.data?.map(
                    (item, index) => (
                      <TableRow key={index}>
                        <TableCell className="no">{index + 1}</TableCell>
                        <TableCell className="city">
                          {item.cityName}
                        </TableCell>
                        <TableCell className="customer">
                          {item.customerName}
                        </TableCell>
                        <TableCell className="fuelSurcharge">
                          {item.fuelSurcharge ? item.fuelSurcharge : "-"}
                        </TableCell>
                        <TableCell className="startDate">
                          {item.startDate}
                        </TableCell>
                        <TableCell className={classes.error}>
                          <span className="errorMsg" dangerouslySetInnerHTML={{__html: item.error}}/>
                        </TableCell>
                      </TableRow>
                    )
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </DialogContent>
      <DialogActions className="bottom-button-block">
        <Button
          className="primary-btn gray-border-btn"
          color="inherit"
          disableElevation
          underlinenone="true"
          onClick={props.handleClose}
        >
          CLOSE
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default Popup;